import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getComprehensiveReport } from '../services/api';

// Async thunk for fetching comprehensive revenue report
export const fetchComprehensiveReport = createAsyncThunk(
  'comprehensiveReport/fetch',
  async (filters, { rejectWithValue }) => {
    try {
      const response = await getComprehensiveReport(filters);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch comprehensive report');
    }
  }
);

const comprehensiveReportSlice = createSlice({
  name: 'comprehensiveReport',
  initialState: {
    data: null,
    loading: false,
    error: null,
    filters: {
      period: '6months',
      from_date: '',
      to_date: '',
      facility: '',
      pitch: ''
    }
  },
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    clearReport: (state) => {
      state.data = null;
      state.error = null;
    },
    resetError: (state) => {
      state.error = null;
    },
    clearFilters: (state) => {
      state.filters = {
        period: '6months',
        from_date: '',
        to_date: '',
        facility: '',
        pitch: ''
      };
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchComprehensiveReport.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchComprehensiveReport.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        state.error = null;
      })
      .addCase(fetchComprehensiveReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { setFilters, clearReport, resetError, clearFilters } = comprehensiveReportSlice.actions;
export default comprehensiveReportSlice.reducer; 